module.exports = __webpack_public_path__ + "img/kwaiProDownload3.d54021f.png";